export default `
  mutation deleteWorkflow($workflowId: String!, $projectId: String!) {
    deleteWorkflow(workflowId: $workflowId, projectId: $projectId) {
      projectId
      deleteWorkflow {
        id
      }
    }
  }
`
